import { revokeAccountBadgesBulkActionName, } from '../../../../backend/features/badges/shared';
import { useBadgingTranslation } from '../../../../ui/hooks';
import { getFilterForBulkAction } from '../../../../ui/util/getFilterForBulkAction';
import { showFormDialog } from '@juvare/common-form-ui/showFormDialog';
import { showErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { launchBulkAction } from '@juvare/platform-sdk-react/ui/features/bulk-actions';
import { revokeBadgeFormConfig } from '../forms/revokeBadgeForm';
export function useAccountBadgeRevokeBulkAction({ badgeId, accountBadgeSelectedIds, onClose, appliedStorageFilters, filteredRowCount, }) {
    const { t } = useBadgingTranslation();
    const bulkActionFilters = getFilterForBulkAction(accountBadgeSelectedIds, appliedStorageFilters);
    const handleRevoke = () => {
        showFormDialog({
            title: t('badges.badgeDetails.accountBadgeTable.bulkActions.revoke.title', {
                count: accountBadgeSelectedIds.length > 0 ? accountBadgeSelectedIds.length : filteredRowCount,
            }),
            config: revokeBadgeFormConfig(t),
            submitLabel: t('badges.badgeDetails.accountBadgeTable.bulkActions.revoke.submit'),
            onSubmit: ({ revokedBadgeReasonsClassifierId, revokeReasonDescription }) => {
                launchBulkAction({
                    title: t('badges.badgeDetails.accountBadgeTable.bulkActions.revoke.progressMessage'),
                    type: revokeAccountBadgesBulkActionName,
                    params: { badgeId, revokedBadgeReasonsClassifierId, revokeReasonDescription, filter: bulkActionFilters },
                    runSync: false,
                    onClose: ({ status, result }) => {
                        if (status === 'finished') {
                            showAlertSnackbar({
                                horizontalPosition: 'center',
                                type: (result === null || result === void 0 ? void 0 : result.updatedCount) ? 'success' : 'error',
                                verticalPosition: 'bottom',
                                autoHideDuration: 2000,
                                message: (result === null || result === void 0 ? void 0 : result.updatedCount)
                                    ? t('badges.badgeDetails.accountBadgeTable.bulkActions.revoke.successMessage', {
                                        count: result.updatedCount,
                                    })
                                    : t('badges.badgeDetails.accountBadgeTable.bulkActions.invalidMessage', {
                                        action: 'Revoke',
                                    }),
                            });
                            onClose();
                        }
                        else if (status === 'failed') {
                            showErrorDialog({
                                title: t('badges.badgeDetails.accountBadgeTable.bulkActions.revoke.failedMessage'),
                            });
                        }
                    },
                });
            },
            sx: {
                pt: 0,
            },
        });
    };
    return {
        handleRevoke,
    };
}
